import { useState, useEffect } from 'react';
import useUrlFragment from "Utils/Hooks/useUrlFragment";
import useSession from './useSession';
import useLocalStorage from './useLocalStorage';

/**
 * Fetches and caches the Patron's session data when the URL changes.
 * Triggers when the url contains the fragment: #<sessionId>.
 */
function useSessionIdWatcher() {

  const { sessionId, session, fetchSession } = useSession();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [localSessionId] = useLocalStorage("vip-patron-session");
  const fragment = useUrlFragment();

  // Update Session info when URL changes
  useEffect(() => {
    // Assume fragment is a Session ID.
    const urlSessionId = fragment;

    const params = new URLSearchParams(window.location.search);
    const loading = params.get('loading');
    const isOAuthRedirect = params.get('oauth_state_id') ? true : false;
    const sessionIdFromLocalStorage = sessionId ? sessionId : (isOAuthRedirect ? localSessionId?.sessionId : null);

    if (loading === 'true') {
      // Show loading spinner instead of checking for sessionId.
      // Useful for async VIP button to show loading screen while Operator is requesting a session.
      return;
    }

    if (urlSessionId && localStorage && localStorage.getItem("expired-key")) {
      const previousSessionId = localStorage.getItem("expired-key");
      if (previousSessionId) {
        if (urlSessionId === previousSessionId) {
          setError(true);
          setIsLoading(false);
          return;
        }
      }
    }

    // No existing session and no ID being set from URL.
    if (!urlSessionId && !sessionId) {
      setError(true);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    fetchSession(false, isOAuthRedirect, urlSessionId || sessionId || sessionIdFromLocalStorage)
      .then(() => setError(false))
      .catch(() => setError(true))
      .finally(() => setIsLoading(false));
  }, [fragment]);

  return { isLoading, session, sessionId, error }
};

export default useSessionIdWatcher;
